import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class FreeTextEventMappingSearchCriteria extends ValueObject {
    public searchCriteria: string = "";
}